import type { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { ViewSwimlaneActions } from './swimlanes.store';
import { ViewsDataService } from '../../services/views-data.service';

@Injectable({ providedIn: 'root' })
export class SwimlaneEffects {
  private readonly actions$ = inject(Actions);
  private readonly viewsHttpService = inject(ViewsDataService);

  public fetchOne$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewSwimlaneActions.fetch),
      switchMap(({ payload: { storeSwimlaneGroupId, dataSourceId, data, queryParams } }) =>
        this.viewsHttpService.fetchSwimlanes(dataSourceId, data, queryParams).pipe(
          map(response =>
            ViewSwimlaneActions.fetchSuccess({
              payload: {
                data: { ...response, id: storeSwimlaneGroupId },
                concat: (queryParams?.page ?? 0) > 1,
              },
            }),
          ),
          catchError((error: HttpErrorResponse) =>
            of(ViewSwimlaneActions.fetchFailed({ payload: { error, id: storeSwimlaneGroupId } })),
          ),
        ),
      ),
    ),
  );
}
